module.exports = __webpack_public_path__ + "static/media/subject_bg.27eb8b97.jpg";